<template>
  <base-form :title="$t('settings.emails.edit', {name: emailData.subject})"
             :loading="loading"
             @submit="onSubmit"
             class="email-settings">
    <template v-slot:header-right>
      <base-button type="primary"
                   class="mr-2"
                   outline
                   size="sm"
                   @click="showTestEmailModal = true">
        {{$t('generic.sendTestEmail')}}
      </base-button>

      <base-button type="default"
                   outline
                   size="sm"
                   @click="goBack">
        {{$t('generic.back')}}
      </base-button>
    </template>
    <fg-input :error="getError($t('settings.emails.subject'))"
              :label="$t('settings.emails.subject')"
              v-model="emailData.subject"
              v-validate="'required'"
              :name="$t('settings.emails.subject')"
              required>
    </fg-input>
    <fg-input :error="getError($t('settings.emails.content'))"
              :label="$t('settings.emails.content')"
              required>
      <html-editor v-model="emailData.content"
                   v-validate="'required'"
                   :name="$t('settings.emails.content')"
                   :variables="emailVariables"
                   ref="editor">
      </html-editor>
    </fg-input>

    <modal v-if="showTestEmailModal"
           :show.sync="showTestEmailModal"
           :title="$t('generic.sendTestEmail')">
      <fg-input required
                :label="$t('generic.jobBoard')"
                :error="getError($t('generic.jobBoard'))">
        <job-board-autocomplete :placeholder="$t('generic.jobBoard')"
                                :name="$t('generic.jobBoard')"
                                v-model="testEmailForm.job_board_id"
                                v-validate="'required'">
        </job-board-autocomplete>
      </fg-input>
      <fg-input required
                :label="$t('generic.email')"
                :name="$t('generic.email')"
                :placeholder="$t('generic.email')"
                :error="getError($t('generic.email'))"
                v-model="testEmailForm.email"
                v-validate="'required'"
      >
      </fg-input>

      <template v-slot:footer>
        <div class="flex w-full justify-center py-3">
          <submit-button :loading="loading"
                         @click="sendTestEmail">
            {{$t('generic.save')}}
          </submit-button>
        </div>
      </template>
    </modal>

  </base-form>
</template>
<script>
  import HtmlEditor from 'src/components/Wysiwyg/RedactorWysiwyg'
  import EmailTemplateService from 'src/services/EmailTemplateService'
  import JobBoardAutocomplete from 'src/components/Autocomplete/JobBoardAutocomplete'
  import { Select, Option } from 'element-ui'
  import { convertToRedactorHtml, parseRedactorHtml } from 'src/views/admin/settings/Email/emailParser'

  export default {
    name: 'email-edit',
    components: {
      HtmlEditor,
      JobBoardAutocomplete,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data () {
      return {
        email: '',
        loading: false,
        showTestEmailModal: false,
        selectedPlaceholder: null,
        emailData: {},
        testEmailForm: {
          job_board_id: 1,
          email: '',
          locale: this.$store.state.config.textLanguage || 'en',
        }
      }
    },
    computed: {
      emailVariables () {
        if (this.emailData.placeholders) {
          return this.emailData.placeholders.map(p => p.name)
        }
        return []
      }
    },
    methods: {
      async languageChange () {
        const {data} = await EmailTemplateService.getById(this.$route.params.id)
        this.parseEmailData(data)
      },
      parseEmailData (emailData) {
        emailData.content = convertToRedactorHtml(emailData.content)
        this.emailData = emailData
      },
      async onSubmit () {
        let valid = await this.$validator.validateAll()
        if (valid) {
          try {
            this.loading = true
            let data = {
              ...this.emailData
            }
            data.content = parseRedactorHtml(data.content)
            data.content = data.content.replace(/\\/g, '')
            data.subject = data.subject.replace(/\\/g, '')
            await EmailTemplateService.update(data.id, data)
          } finally {
            this.loading = false
          }
        }
      },
      async sendTestEmail() {
        let valid = await this.$validator.validateAll()

        if (!valid) {
          return
        }
        try {
          this.loading = true
          await EmailTemplateService.sendTestEmail(this.$route.params.id, this.testEmailForm)
          this.showTestEmailModal = false
          this.$notify({
            type: 'success',
            message: this.$t('settings.email.sendTest.success')
          })
        } finally {
          this.loading = false
        }
      },
      goBack() {
        this.$router.go(-1)
      }
    },
    watch: {
      '$store.state.config.textLanguage': {
        immediate: true,
        handler () {
          this.languageChange()
        }
      },
    },
    async beforeRouteEnter (to, from, next) {
      try {
        let id = to.params.id
        let res = await EmailTemplateService.getById(id)
        let emailData = res.data
        if (emailData) {
          next(vm => {
            vm.parseEmailData(emailData)
          })
        } else {
          next(vm => vm.error = 'No data')
        }
      } catch (e) {
        next(vm => vm.error = e)
      }
    }
  }
</script>
<style lang="scss">
  .email-settings .placeholder-select {
    width: 200px;
  }
</style>
